import apiClient from '@u/apiClient'
import GetVersionNoteListController from '@/wayfinder/actions/App/Http/Controllers/VersionNote/GetVersionNoteListController'

export default {
  // region fetch
  fetchAllVersionNotes({ commit }, payload?: { page?: number }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetVersionNoteListController.get({
            query: { page: payload?.page ?? 1 }
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
  // endregion
}
